import { type StyleToken } from './style-token';

export const GLOBAL_STYLE_TOKENS: StyleToken[] = [
  {
    type: 'style',
    scope: 'global',
    value: '--theme-canvas',
    label: 'Canvas',
    renderValue: '--bat-canvas',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-fill',
    label: 'Fill',
    renderValue: '--bat-fill',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-value',
    label: 'Value Color',
    renderValue: '--bat-value',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-font-family',
    label: 'Font Family',
    renderValue: '--bat-fontFamily',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-line-height',
    label: 'Line Height',
    renderValue: '--bat-lineHeight',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-radius',
    label: 'Border Radius',
    renderValue: '--bat-radius',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-font-size',
    label: 'Font Size',
    renderValue: '--bat-fontSize',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-complementary',
    label: 'Complementary',
    renderValue: '--bat-complementary',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-title',
    label: 'Title Color',
    renderValue: '--bat-title',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-outline',
    label: 'Outline',
    renderValue: '--bat-outline',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-accent',
    label: 'Accent',
    renderValue: '--bat-accent',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-accent-label',
    label: 'Accent Label',
    renderValue: '--bat-accentLabel',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-header-font-size',
    label: 'Header Font Size',
    renderValue: '--bat-headerFontSize',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-header-font-family',
    label: 'Header Font Family',
    renderValue: '--bat-headerFontFamily',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-header-font-weight',
    label: 'Header Font Weight',
    renderValue: '--bat-headerFontWeight',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-label-font-weight',
    label: 'Label Font Weight',
    renderValue: '--bat-labelFontWeight',
  },
  {
    type: 'style',
    scope: 'global',
    value: '--theme-font-weight',
    label: 'Font Weight',
    renderValue: '--bat-fontWeight',
  },
];
